// Present the official Lazio tariff code without changing its namespaced DB key.
// Different Lazio sections can share the same official article code.
export function displayPricebookCode(row) {
  if (!row) return "—";
  const code = row.code || "";
  if (row.region === "Lazio" && String(row.year) === "2023" && /^LAZ23-[A-HS]-/i.test(code)) {
    const section = (row.section || code.match(/^LAZ23-([A-HS])-/i)?.[1] || "").toUpperCase();
    const official = row.official_code_canonical || row.official_code?.trim().replace(/\.$/, "") || code.replace(/^LAZ23-[A-HS]-/i, "");
    return section ? `${section}-${official}` : official;
  }
  return code || row.parent_code || "—";
}
